"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

var _ScreenReaderOnly = _interopRequireDefault(require("../ScreenReaderOnly"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: top;\n  display: inline-block;\n  width: 100%;\n  background-color: ", ";\n  animation: ", " 4s infinite ease-in;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  box-sizing: border-box;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  border: ", ";\n  top: 10px;\n  left: 50%;\n  transform: translateX(-15px);\n  animation: ", " 4s infinite ease;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  min-height: 50px;\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% { height: 0%; }\n  25% { height: 0%; }\n  50% { height: 100%; }\n  75% { height: 100%; }\n  100% { height: 0%; }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  25% { transform: rotate(180deg); }\n  50% { transform: rotate(180deg); }\n  75% { transform: rotate(360deg); }\n  100% { transform: rotate(360deg); }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var spinnerOuterAnimation = (0, _styledComponents.keyframes)(_templateObject());
var spinnerInnerAnimation = (0, _styledComponents.keyframes)(_templateObject2());

var Root = _styledComponents.default.div(_templateObject3());

var SpinnerOuter = _styledComponents.default.span(_templateObject4(), function (props) {
  return props.inverted ? "4px solid ".concat(props.theme.colorPrimaryLight) : "4px solid ".concat(props.theme.colorPrimaryDark);
}, spinnerOuterAnimation);

var SpinnerInner = _styledComponents.default.span(_templateObject5(), function (props) {
  return props.inverted ? props.theme.colorPrimaryLight : props.theme.colorPrimaryDark;
}, spinnerInnerAnimation);

var LoadingIndicator = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadingIndicator, _React$Component);

  function LoadingIndicator() {
    _classCallCheck(this, LoadingIndicator);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingIndicator).apply(this, arguments));
  }

  _createClass(LoadingIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hiddenText = _this$props.hiddenText,
          inverted = _this$props.inverted,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["hiddenText", "inverted", "theme"]);

      return _react.default.createElement(Root, _extends({
        className: "hw-loading-indicator-wrapper"
      }, otherProps), _react.default.createElement(_ScreenReaderOnly.default, null, hiddenText), _react.default.createElement(SpinnerOuter, {
        className: "hw-loading-indicator",
        inverted: inverted,
        theme: theme
      }, _react.default.createElement(SpinnerInner, {
        className: "hw-loading-indicator-inner",
        inverted: inverted,
        theme: theme
      })));
    }
  }]);

  return LoadingIndicator;
}(_react.default.Component);

LoadingIndicator.propTypes = {
  hiddenText: _propTypes.default.string,
  inverted: _propTypes.default.bool,
  theme: _propTypes.default.shape({
    colorPrimaryLight: _propTypes.default.string,
    colorPrimaryDark: _propTypes.default.string
  })
};
LoadingIndicator.defaultProps = {
  hiddenText: 'Loading page',
  inverted: false,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(LoadingIndicator);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/LoadingIndicator/index.js